module.exports = __webpack_public_path__ + "static/media/bg-timer-tablet.2ed534fe.png";